import React from 'react'
import { SpinnerDiv } from './styles'

export const Spinner = (props) => {
  const { $size, $borderColor, $speed, ...rest } = props
  return <SpinnerDiv $size={$size} $borderColor={$borderColor} $speed={$speed} {...rest} />
}
